<script setup lang="ts">
import { EPageSectionType } from '@/modules/adminModule/constants/pagesCMSconstants'

const { locale } = useI18n()
const { $notyf } = useNuxtApp()
const url = useRequestURL()
const config = useNuxtApp().$config

// sections
const pageSections = ref<IHomePageSectionModel[]>()
const pageMetaObject = ref<{ [key: string]: string } | undefined>()
const pageHeaderSection = ref<ICMSLocationContent>()
const pageTextSection = ref<ICMSLocationContent>()
const pageFaqSection = ref<ICMSLocationContent>()
const metaContent = ref<ICMSLocationContentTranslations>()
provide('pageHeaderSection', pageHeaderSection)
provide('pageTextSection', pageTextSection)
provide('pageFaqSection', pageFaqSection)
provide('pageSections', pageSections)
const subpagesContentStore = useSubpagesContentStore()
const getPageSections = async () => {
	try {
		const response = await subpagesContentStore.fetchPageSections('insurance-replacement')
		pageSections.value = response
		pageHeaderSection.value = pageSections.value?.find((section) => section.name === EPageSectionType.PAGE_HEADER_IMAGE)
		pageMetaObject.value = pageSections.value?.find((section) => section.name === EPageSectionType.META)
		pageTextSection.value = pageSections.value?.find((section) => section.name === EPageSectionType.CONTENT_SECTION)
		pageFaqSection.value = pageSections.value?.find((section) => section.name === EPageSectionType.FAQ)
		metaContent.value = pageMetaObject.value?.translations.find((translation) => translation.language === locale.value)?.content[0]
	} catch (error) {
		$notyf.error('Error while fetching page sections')
		logger.log(error)
	}
}

await getPageSections()

const robotsCalculated = useRobotsMeta(() => metaContent.value?.robots)

usePageViewed(EGTMPageType.INSURANCE_REPLACEMENT)
</script>

<template>
	<div>
		<!-- definePageMeta -->
		<Head>
			<Title>{{ metaContent?.title ? ensureBrandSuffix(metaContent.title) : `${$t('pages.insurance_replacement.header')} | CarFree` }}</Title>
			<Meta name="description" :content="metaContent?.description ?? ''" />
			<Meta v-if="config.public.isIndex" name="robots" :content="robotsCalculated" />
			<Meta v-else name="robots" content="noindex, nofollow" />
			<Link
				rel="canonical"
				:href="metaContent?.canonical && metaContent?.canonical?.trim() !== '' ? metaContent?.canonical : `${url.origin}${url.pathname}`" />
		</Head>

		<GlobalHeader />
		<CarRentalPageHero :title="$t('pages.insurance_replacement.header')" hideContactForm />
		<HomePageChooseCar :modal-form="true" :min-months="1" :max-months="12" init />
		<LazyCarRentalTextSection class="insurance-replacement__content" />
		<LazyCarRentalFaq :pageTitle="$t('pages.insurance_replacement.header')" />
		<LazyGlobalApplicationBanner :without-margin="true" />
	</div>
</template>

<style scoped lang="scss">
.insurance-replacement__content {
	margin-top: 86px;
	margin-bottom: 32px;
}
</style>
